export default "assets/images/icons/arrow-white-circle-51f8f359.svg";